/** @jsx h */

import { Fragment } from 'preact';
import FilterTomSelect from './FilterTomSelect';

const FilterContainer = ({
  facets,
  facetsActive,
  sorting,
  triggerAjaxSubmit,
  pluginNamespace,
  isReset,
}) => {
  return (
    <Fragment>
      <div className="search-form__filters">
        <ul className="search__selectfields">
          {facets.map((facet, index) => (
            <FilterTomSelect
              id={index}
              key={facet.label}
              facet={facet}
              isReset={isReset}
              filterName={facet.name}
              pluginNamespace={pluginNamespace}
              triggerAjaxSubmit={triggerAjaxSubmit}
            />
          ))}
        </ul>
      </div>
    </Fragment>
  );
};

export default FilterContainer;
